'use client'

import { Button, EmptyState } from '@vinted/web-ui'

import { useAsset } from '@marketplace-web/shared/assets'

type Props = {
  title: string
  body: string
  action: string
  onActionClick: () => void
}

const ASSET_BASE = 'assets/error-page'
const ASSET_DIMENSION = 256

const ErrorContent = ({ title, body, action, onActionClick }: Props) => {
  const asset = useAsset(ASSET_BASE)

  return (
    <div className="fullpage-layout u-background-white small-container u-flexbox u-justify-content-center u-align-items-center u-flex-grow error-display">
      <EmptyState
        image={
          <video
            muted
            playsInline
            autoPlay
            loop
            width={ASSET_DIMENSION}
            height={ASSET_DIMENSION}
            poster={asset('error.png')}
          >
            <source src={asset('error.mp4')} type="video/mp4" />
            <source src={asset('error.webm')} type="video/webm" />
          </video>
        }
        title={title}
        body={body}
        action={<Button onClick={onActionClick} text={action} styling="filled" />}
      />
    </div>
  )
}
export default ErrorContent
